<cl-menu [Id]="MenuId" [Logo]="Logo" [Title]="Title" [User]="User?.userName || 'Usuario'" [Nodes]="MenuNodes">
    <div class="exclude" style="width: 100%">
        <mat-toolbar class="Base toolbar-padding" fxLayout="row wrap" fxLayoutAlign="space-between center">
            <div fxLayoutAlign="none center" fxLayoutGap="20px">
                <button mat-icon-button (click)="ToggleMenu()">
                    <mat-icon>menu</mat-icon>
                </button>
                <mat-label class="toolbar-title">{{txtaccion}}</mat-label>
            </div>
            <div fxLayoutAlign="none center" fxLayoutGap="5px">
              <div class="avatar-container">
                <img [src]="'assets/user.png'"
                     alt="User avatar"
                     class="user-avatar">
              </div>
              <div class="user-text">
                <span class="user-name">
                  {{User?.userName || 'Usuario'}} | {{User?.email || ''}}
                </span>
              </div>
            </div>
        </mat-toolbar>
        <router-outlet class="exclude"></router-outlet>
    </div>
</cl-menu>
